export const DELETE_TYPES = {
    DELETE_AND_ASSIGN_CHILDREN_TO_PARENT: 'DELETE_AND_ASSIGN_CHILDREN_TO_PARENT',
    DELETE_AND_DELETE_COMPLETE_SUBTREE: 'DELETE_AND_DELETE_COMPLETE_SUBTREE',
    DELETE_CAPABILITY: 'DELETE_CAPABILITY'
}
